import React from "react";
import { InputBase, Paper, IconButton } from "@mui/material";
import { makeStyles } from "@mui/styles";
import SearchIcon from "@mui/icons-material/Search";

const useStyles = makeStyles(() => ({
  searchBox: {
    display: "flex",
    alignItems: "center",
    width: "250px",
    height: "32px",
    padding: "2.5px 0",
  },
  iconButton: {
    padding: "5px",
  },
  inputBase: {
    marginLeft: "8px",
    flex: 1,
  },
}));

const SearchBar = ({ onSearchChange }) => {
  const classes = useStyles();

  return (
    <Paper className={classes.searchBox}>
      <IconButton className={classes.iconButton} aria-label="search">
        <SearchIcon />
      </IconButton>
      <InputBase
        className={classes.inputBase}
        placeholder="Search"
        onChange={(e) => onSearchChange(e.target.value)}
        inputProps={{ "aria-label": "search" }}
      />
    </Paper>
  );
};

export default SearchBar;
